enum SYSTEM_MODALS {
  ADD_DONATION = 'ADD_DONATION',
  ADD_PARTNER_TO_ANIMAL = 'ADD_PARTNER_TO_ANIMAL',
  ADD_PEOPLE_TO_ANIMAL = 'ADD_PEOPLE_TO_ANIMAL',
  ADMIN_ATLAS_SEARCH_FLAGS_CONFIRM = 'ADMIN_ATLAS_SEARCH_FLAGS_CONFIRM',
  ADMIN_MIGRATE_BITE_REPORT_IMAGES = 'ADMIN_MIGRATE_BITE_REPORT_IMAGES',
  ADMIN_MIGRATE_BITES = 'ADMIN_MIGRATE_BITES',
  ADMIN_MIGRATE_CASE_ANIMAL_FORMS = 'ADMIN_MIGRATE_CASE_ANIMAL_FORMS',
  ADMIN_MIGRATE_FS_ACTIVITY_IMAGES = 'ADMIN_MIGRATE_FS_ACTIVITY_IMAGES',
  ADMIN_MIGRATE_OUTCOME_CONTRACTS = 'ADMIN_MIGRATE_OUTCOME_CONTRACTS',
  ADMIN_MIGRATE_PEOPLE_CUSTOM_FIELDS = 'ADMIN_MIGRATE_PEOPLE_CUSTOM_FIELDS',
  ADMIN_REVIEW_OUTCOME_CONTRACTS = 'ADMIN_REVIEW_OUTCOME_CONTRACTS',
  ADMIN_ADOPTION_EDIT_STRIPE_ID = 'ADMIN_ADOPTION_EDIT_STRIPE_ID',
  ADOPTION_APPLICATIONS = 'ADOPTION_APPLICATIONS',
  ADOPTION_ADD_ANIMAL_TO_APPLICATION = 'ADOPTION_ADD_ANIMAL_TO_APPLICATION',
  ADOPTION_APPROVAL = 'ADOPTION_APPROVAL',
  ADOPTION_COMPLETE = 'ADOPTION_COMPLETE',
  ANIMAL_ADD_BEHAVIOR_FOLLOWUP = 'ANIMAL_ADD_BEHAVIOR_FOLLOWUP',
  ANIMAL_ADD_DIAGNOSTIC = 'ANIMAL_ADD_DIAGNOSTIC',
  ANIMAL_ADD_GUARDIAN = 'ANIMAL_ADD_GUARDIAN',
  ANIMAL_ADD_GUARDIAN_PARTNER = 'ANIMAL_ADD_GUARDIAN_PARTNER',
  ANIMAL_ADD_LOCATION = 'ANIMAL_ADD_LOCATION',
  ANIMAL_ADD_MEDICATION = 'ANIMAL_ADD_MEDICATION',
  ANIMAL_ADD_PROCEDURE = 'ANIMAL_ADD_PROCEDURE',
  ANIMAL_ADD_SURGERY = 'ANIMAL_ADD_SURGERY',
  ANIMAL_ADD_VACCINATIONS = 'ANIMAL_ADD_VACCINATIONS',
  ANIMAL_ADD_VIDEOS = 'ANIMAL_ADD_VIDEOS',
  ANIMAL_ADD_WEIGHT = 'ANIMAL_ADD_WEIGHT',
  ANIMAL_CANCEL_MEDICATION = 'ANIMAL_CANCEL_MEDICATION',
  ANIMAL_CHANGE_KENNEL_MODAL = 'ANIMAL_CHANGE_KENNEL_MODAL',
  ANIMAL_CLOSE_VOUCHER = 'ANIMAL_CLOSE_VOUCHER',
  ANIMAL_DELETE_DIAGNOSTIC = 'ANIMAL_DELETE_DIAGNOSTIC',
  ANIMAL_DELETE_EXAM = 'ANIMAL_DELETE_EXAM',
  ANIMAL_DELETE_EXAM_FOLLOWUP = 'ANIMAL_DELETE_EXAM_FOLLOWUP',
  ANIMAL_DELETE_FOSTER_HISTORY_RECORD = 'ANIMAL_DELETE_FOSTER_HISTORY_RECORD',
  ANIMAL_DELETE_KENNEL_HISTORY = 'ANIMAL_DELETE_KENNEL_HISTORY',
  ANIMAL_DELETE_MEDICATION = 'ANIMAL_DELETE_MEDICATION',
  ANIMAL_DELETE_MEDICATION_FOLLOWUP = 'ANIMAL_DELETE_MEDICATION_FOLLOWUP',
  ANIMAL_DELETE_PHOTOS = 'ANIMAL_DELETE_PHOTOS',
  ANIMAL_DELETE_PROCEDURE = 'ANIMAL_DELETE_PROCEDURE',
  ANIMAL_DELETE_PROCEDURE_FOLLOWUP = 'ANIMAL_DELETE_PROCEDURE_FOLLOWUP',
  ANIMAL_DELETE_PROFILE = 'ANIMAL_DELETE_PROFILE',
  ANIMAL_DELETE_SURGERY = 'ANIMAL_DELETE_SURGERY',
  ANIMAL_DELETE_SURGERY_FOLLOWUP = 'ANIMAL_DELETE_SURGERY_FOLLOWUP',
  ANIMAL_DELETE_VACCINATION = 'ANIMAL_DELETE_VACCINATION',
  ANIMAL_DELETE_VIDEOS = 'ANIMAL_DELETE_VIDEOS',
  ANIMAL_EDIT_BEHAVIOR = 'ANIMAL_EDIT_BEHAVIOR',
  ANIMAL_EDIT_BEHAVIOR_FOLLOWUP = 'ANIMAL_EDIT_BEHAVIOR_FOLLOWUP',
  ANIMAL_EDIT_DIAGNOSTICS_MODAL = 'ANIMAL_EDIT_DIAGNOSTICS_MODAL',
  ANIMAL_EDIT_DIAGNOSTIC_TEST_RESULT = 'ANIMAL_EDIT_DIAGNOSTIC_TEST_RESULT',
  ANIMAL_EDIT_EXAM_FOLLOWUP = 'ANIMAL_EDIT_EXAM_FOLLOWUP',
  ANIMAL_EDIT_EXAM_MODAL = 'ANIMAL_EDIT_EXAM_MODAL',
  ANIMAL_EDIT_FOSTER_HISTORY_RECORD = 'ANIMAL_EDIT_FOSTER_HISTORY_RECORD',
  ANIMAL_EDIT_KENNEL_HISTORY = 'ANIMAL_EDIT_KENNEL_HISTORY',
  ANIMAL_EDIT_MEDICATION = 'ANIMAL_EDIT_MEDICATION',
  ANIMAL_EDIT_MEDICATION_FOLLOWUP = 'ANIMAL_EDIT_MEDICATION_FOLLOWUP',
  ANIMAL_EDIT_PROCEDURE = 'ANIMAL_EDIT_PROCEDURE',
  ANIMAL_EDIT_PROCEDURE_FOLLOWUP = 'ANIMAL_EDIT_PROCEDURE_FOLLOWUP',
  ANIMAL_EDIT_SURGERY_FOLLOWUP = 'ANIMAL_EDIT_SURGERY_FOLLOWUP',
  ANIMAL_EDIT_SURGERY_MODAL = 'ANIMAL_EDIT_SURGERY_MODAL',
  ANIMAL_EDIT_SURGERY_PROCEDURE = 'ANIMAL_EDIT_SURGERY_PROCEDURE',
  ANIMAL_EDIT_VACCINATIONS_MODAL = 'ANIMAL_EDIT_VACCINATIONS_MODAL',
  ANIMAL_EDIT_VACCINATION_DOSES = 'ANIMAL_EDIT_VACCINATION_DOSES',
  ANIMAL_EMAIL_VOUCHER = 'ANIMAL_EMAIL_VOUCHER',
  ANIMAL_END_FOSTER = 'ANIMAL_END_FOSTER',
  ANIMAL_EDIT_MULTIPLE_STATUS = 'ANIMAL_EDIT_MULTIPLE_STATUS',
  ANIMAL_EDIT_MULTIPLE_TAGS = 'ANIMAL_EDIT_MULTIPLE_TAGS',
  ANIMAL_EDIT_MULTIPLE_WAIVERS = 'ANIMAL_EDIT_MULTIPLE_WAIVERS',
  ANIMAL_EDIT_MULTIPLE_NOTES = 'ANIMAL_EDIT_MULTIPLE_NOTES',
  ANIMAL_EDIT_MULTIPLE_ANIMAL_FIELDS = 'ANIMAL_EDIT_MULTIPLE_ANIMAL_FIELDS',
  ANIMAL_EDIT_MULTIPLE_RFC = 'ANIMAL_EDIT_MULTIPLE_RFC',
  ANIMAL_EXAM_NEW_FOLLOWUP = 'ANIMAL_EXAM_NEW_FOLLOWUP',
  ANIMAL_BITE_REPORT_PERMISSION_ALERT = 'ANIMAL_BITE_REPORT_PERMISSION_ALERT',
  ANIMAL_NEW_HOLD_LIMITS_MODAL = 'ANIMAL_NEW_HOLD_LIMITS_MODAL',
  ANIMAL_MERGE = 'ANIMAL_MERGE',
  ANIMAL_MULTIPLE_MEDICATION_DOSES = 'ANIMAL_MULTIPLE_MEDICATION_DOSES',
  ANIMAL_NEW_BEHAVIOR = 'ANIMAL_NEW_BEHAVIOR',
  ANIMAL_NEW_BITE_REPORT = 'ANIMAL_NEW_BITE_REPORT',
  ANIMAL_EDIT_BITE_REPORT = 'ANIMAL_EDIT_BITE_REPORT',
  ANIMAL_BITE_FOLLOWUPS = 'ANIMAL_BITE_FOLLOWUPS',
  ANIMAL_NEW_EXAM = 'ANIMAL_NEW_EXAM',
  ANIMAL_PETCO_LOVE_LOST_DELETE = 'ANIMAL_PETCO_LOVE_LOST_DELETE',
  ANIMAL_PETCO_LOVE_LOST_SYNC = 'ANIMAL_PETCO_LOVE_LOST_SYNC',
  ANIMAL_PHOTOS_HIDE = 'ANIMAL_PHOTOS_HIDE',
  ANIMAL_PRINT_SURGERY_FORM = 'ANIMAL_PRINT_SURGERY_FORM',
  ANIMAL_REMOVE_OWNER = 'ANIMAL_REMOVE_OWNER',
  ANIMAL_SCHEDULE_FOLLOWUP = 'ANIMAL_SCHEDULE_FOLLOWUP',
  ANIMAL_SCHEDULE_PROCEDURE_FOLLOWUP = 'ANIMAL_SCHEDULE_PROCEDURE_FOLLOWUP',
  ANIMAL_SURGERY_NEW_FOLLOWUP = 'ANIMAL_SURGERY_NEW_FOLLOWUP',
  ANIMAL_TOP_ACTION_ADOPTION_LINK = 'ANIMAL_TOP_ACTION_ADOPTION_LINK',
  ANIMAL_TOP_ACTION_BANNER = 'ANIMAL_TOP_ACTION_BANNER',
  ANIMAL_TOP_ACTION_CS = 'ANIMAL_TOP_ACTION_CS',
  ANIMAL_TOP_ACTION_DECEASED = 'ANIMAL_TOP_ACTION_DECEASED',
  ANIMAL_TOP_ACTION_FS = 'ANIMAL_TOP_ACTION_FS',
  ANIMAL_TOP_ACTION_INTAKE = 'ANIMAL_TOP_ACTION_INTAKE',
  ANIMAL_TOP_ACTION_LF = 'ANIMAL_TOP_ACTION_LF',
  ANIMAL_TOP_ACTION_REHOME = 'ANIMAL_TOP_ACTION_REHOME',
  ANIMAL_TOP_ACTION_REVERSE_OUTCOME = 'ANIMAL_TOP_ACTION_REVERSE_OUTCOME',
  ANIMAL_TOP_ACTION_RFC = 'ANIMAL_TOP_ACTION_RFC',
  ANIMAL_TOP_ACTION_START_FOSTER = 'ANIMAL_TOP_ACTION_START_FOSTER',
  ANIMAL_TOP_ACTION_TNVR = 'ANIMAL_TOP_ACTION_TNVR',
  ANIMAL_TOP_ACTION_VOUCHER = 'ANIMAL_TOP_ACTION_VOUCHER',
  ANIMAL_UPDATE_MEDICATION_DOSE = 'ANIMAL_UPDATE_MEDICATION_DOSE',
  ANIMAL_UPDATE_PROCEDURE = 'ANIMAL_UPDATE_PROCEDURE',
  APPLICATION_DECLINED = 'APPLICATION_DECLINED',
  APPLICATION_DOCUMENTS = 'APPLICATION_DOCUMENTS',
  BASIC_MODAL = 'BASIC_MODAL',
  CART_CUSTOMER_DONATION_ALERT = 'CART_CUSTOMER_DONATION_ALERT',
  CART_EDIT_PRE_PAYMENT = 'CART_EDIT_PRE_PAYMENT',
  CART_DO_NOT_ADOPT_CONFIRM = 'CART_DO_NOT_ADOPT_CONFIRM',
  CART_EMPTY_DIALOG = 'CART_EMPTY_DIALOG',
  CART_FOSTER_EQUIPMENT_RENTAL_DATES = 'CART_FOSTER_EQUIPMENT_RENTAL_DATES',
  CART_PRE_PAYMENT = 'CART_PRE_PAYMENT',
  CART_REMOVE_ANIMAL = 'CART_REMOVE_ANIMAL',
  CART_REMOVE_PRODUCT_CONFIRM = 'CART_REMOVE_PRODUCT_CONFIRM',
  CART_REMOVE_RETAIL_ITEM = 'CART_REMOVE_RETAIL_ITEM',
  CART_RESEND_LINK = 'CART_RESEND_LINK',
  CART_ZERO_TOTAL_CONFIRMATION = 'CART_ZERO_TOTAL_CONFIRMATION',
  COMPLETE_OUTCOME_LOADING_MESSAGE = 'COMPLETE_OUTCOME_LOADING_MESSAGE',
  COMPLETE_DIAGNOSTIC_RESULT = 'COMPLETE_DIAGNOSTIC_RESULT',
  COMPLETE_EXAM = 'COMPLETE_EXAM',
  COMPLETE_BEHAVIOR = 'COMPLETE_BEHAVIOR',
  COMPLETE_MEDICATION_DOSE = 'COMPLETE_MEDICATION_DOSE',
  COMPLETE_MULTIPLE_DOSES = 'COMPLETE_MULTIPLE_DOSES',
  COMPLETE_REQUEST_FOR_CARE = 'COMPLETE_REQUEST_FOR_CARE',
  COMPLETE_PROCEDURE = 'COMPLETE_PROCEDURE',
  COMPLETE_SURGERY = 'COMPLETE_SURGERY',
  COMPLETE_VACCINATION_DOSE = 'COMPLETE_VACCINATION_DOSE',
  COMPLETE_VOUCHER = 'COMPLETE_VOUCHER',
  COMPLETE_MEDICAL_FOLLOWUP = 'COMPLETE_MEDICAL_FOLLOWUP',
  COMPLETE_MULTIPLE_FOLLOWUPS = 'COMPLETE_MULTIPLE_FOLLOWUPS',
  CREATE_DEMO_SHELTER = 'CREATE_DEMO_SHELTER',
  CS_ANIMAL_ADD_MODAL = 'CS_ANIMAL_ADD_MODAL',
  CS_ANIMAL_ADD_VOUCHER = 'CS_ANIMAL_ADD_VOUCHER',
  CS_ANIMAL_INTAKE = 'CS_ANIMAL_INTAKE',
  CS_CONTACT_PARTY = 'CS_CONTACT_PARTY',
  CS_LOCATION_MODAL = 'CS_LOCATION_MODAL',
  DATA_TABLE_DEFAULT_COLUMNS = 'DATA_TABLE_DEFAULT_COLUMNS',
  DATA_TABLE_WEIGHT_MODAL = 'DATA_TABLE_WEIGHT_MODAL',
  DATE_RANGE_EXCEEDED = 'DATE_RANGE_EXCEEDED',
  DELETE_ANIMAL_ADMISSION_HISTORY_RECORD = 'DELETE_ANIMAL_ADMISSION_HISTORY_RECORD',
  DELETE_ANIMAL_HOLD_STATUS_MODAL = 'DELETE_ANIMAL_HOLD_STATUS_MODAL',
  DELETE_ANIMAL_STATUS_REPORT = 'DELETE_ANIMAL_STATUS_REPORT',
  DELETE_BITE_MODAL = 'DELETE_BITE_MODAL',
  DELETE_CITATION_MODAL = 'DELETE_CITATION_MODAL',
  DELETE_CONTACT_MODAL = 'DELETE_CONTACT_MODAL',
  DELETE_CONTACT_PARTY_MODAL = 'DELETE_CONTACT_PARTY_MODAL',
  DELETE_LOCATION = 'DELETE_LOCATION',
  DELETE_MODAL = 'DELETE_MODAL',
  DELETE_TNVR_CALL = 'DELETE_TNVR_CALL',
  DUPLICATED_PERSONS_MODAL = 'DUPLICATED_PERSONS_MODAL',
  EDIT_ANIMAL_STATUS_REPORT = 'EDIT_ANIMAL_STATUS_REPORT',
  EDIT_DONATION = 'EDIT_DONATION',
  EDIT_PERSON_DETAILS = 'EDIT_PERSON_DETAILS',
  EMAIL_RECEIPT = 'EMAIL_RECEIPT',
  EMAIL_SENDER = 'EMAIL_SENDER',
  FILES_ACTION_FILE = 'FILES_ACTION_FILE',
  FOSTER_SETTINGS = 'FOSTER_SETTINGS',
  FS_ANIMAL_ADD_MODAL = 'FS_ANIMAL_ADD_MODAL',
  FS_BITE_MODAL = 'FS_BITE_MODAL',
  FS_CITATION_EMAIL_MODAL = 'FS_CITATION_EMAIL_MODAL',
  FS_CITATION_MODAL = 'FS_CITATION_MODAL',
  FS_CONTACT_ADD_MODAL = 'FS_CONTACT_ADD_MODAL',
  FS_CONTACT_EDIT_MODAL = 'FS_CONTACT_EDIT_MODAL',
  FS_DASHBOARD_ADD_OFFICER_CASE = 'FS_DASHBOARD_ADD_OFFICER_CASE',
  FS_DASHBOARD_ASSIGN_OFFICER = 'FS_DASHBOARD_ASSIGN_OFFICER',
  FS_DASHBOARD_BOARD_UNASSIGN_CONFIRM = 'FS_DASHBOARD_BOARD_UNASSIGN_CONFIRM',
  FS_DASHBOARD_CASE_DETAILS = 'FS_DASHBOARD_CASE_DETAILS',
  FS_DASHBOARD_CASE_WORK_START = 'FS_DASHBOARD_CASE_WORK_START',
  FS_DASHBOARD_JOIN_CASE = 'FS_DASHBOARD_JOIN_CASE',
  FS_STATUS_CLOSES_CLOCKS_CONFIRM = 'FS_STATUS_CLOSES_CLOCKS_CONFIRM',
  FS_DASHBOARD_OFFICER_CASES = 'FS_DASHBOARD_OFFICER_CASES',
  FS_DASHBOARD_STOP_WORKING = 'FS_DASHBOARD_STOP_WORKING',
  FS_DASHBOARD_UNASSIGNED_FILTERS = 'FS_DASHBOARD_UNASSIGNED_FILTERS',
  FS_DELETE_ACTIVITY_MODAL = 'FS_DELETE_ACTIVITY_MODAL',
  FS_LINK_CASES_MODAL = 'FS_LINK_CASES_MODAL',
  FS_LOCATION_MODAL = 'FS_LOCATION_MODAL',
  FS_REPORTING_PARTY_CREATE_MODAL = 'FS_REPORTING_PARTY_CREATE_MODAL',
  FS_REPORTING_PARTY_EDIT_MODAL = 'FS_REPORTING_PARTY_EDIT_MODAL',
  FS_DELETE_REPORTING_PARTY_MODAL = 'FS_DELETE_REPORTING_PARTY_MODAL',
  FS_SCHEDULED_ACTIVITY_CANCEL_MODAL = 'FS_SCHEDULED_ACTIVITY_CANCEL_MODAL',
  FS_SCHEDULED_ACTIVITY_COMPLETE_MODAL = 'FS_SCHEDULED_ACTIVITY_COMPLETE_MODAL',
  FS_SCHEDULED_ACTIVITY_DETAILS_MODAL = 'FS_SCHEDULED_ACTIVITY_DETAILS_MODAL',
  FS_SCHEDULED_ACTIVITY_MODAL = 'FS_SCHEDULED_ACTIVITY_MODAL',
  FS_SCHEDULED_ACTIVITY_PICK_CASE_MODAL = 'FS_SCHEDULED_ACTIVITY_PICK_CASE_MODAL',
  FS_STATEMENT_MODAL = 'FS_STATEMENT_MODAL',
  FS_UNLINK_CASE_MODAL = 'FS_UNLINK_CASE_MODAL',
  GENERATE_MEDICAL_CERTIFICATE = 'GENERATE_MEDICAL_CERTIFICATE',
  GROUP_ADD_ANIMALS = 'GROUP_ADD_ANIMALS',
  GROUP_DELETE = 'GROUP_DELETE',
  GROUP_EDIT = 'GROUP_EDIT',
  GROUP_REMOVE_ANIMALS = 'GROUP_REMOVE_ANIMALS',
  INDIVIDUAL_ADOPTION_APPLICATIONS = 'INDIVIDUAL_ADOPTION_APPLICATIONS',
  INVITE_FOSTER_PORTAL = 'INVITE_FOSTER_PORTAL',
  KENNEL_AVAILABLE = 'KENNEL_AVAILABLE',
  KENNEL_CARD_MODAL = 'KENNEL_CARD_MODAL',
  KENNEL_DELETE = 'KENNEL_DELETE',
  KENNEL_DELETE_LOCATION_MODAL = 'KENNEL_DELETE_LOCATION_MODAL',
  KENNEL_ADD_SITE_MODAL = 'KENNEL_ADD_SITE_MODAL',
  KENNEL_ADD_BUILDING_MODAL = 'KENNEL_ADD_BUILDING_MODAL',
  KENNEL_ADD_LOCATION_MODAL = 'KENNEL_ADD_LOCATION_MODAL',
  KENNEL_ADD_KENNEL_MODAL = 'KENNEL_ADD_KENNEL_MODAL',
  KENNEL_DELETE_MODAL = 'KENNEL_DELETE_MODAL',
  KENNEL_EDIT_SITE_MODAL = 'KENNEL_EDIT_SITE_MODAL',
  KENNEL_EDIT_BUILDING_MODAL = 'KENNEL_EDIT_BUILDING_MODAL',
  KENNEL_EDIT_LOCATION_MODAL = 'KENNEL_EDIT_LOCATION_MODAL',
  KENNEL_HISTORY_MODAL = 'KENNEL_HISTORY_MODAL',
  KENNEL_LOCATION_MODAL = 'KENNEL_LOCATION_MODAL',
  KENNEL_MANAGER_SELECT_ANIMAL = 'KENNEL_MANAGER_SELECT_ANIMAL',
  KENNEL_MANAGER_STATE = 'KENNEL_MANAGER_STATE',
  KENNEL_MODAL = 'KENNEL_MODAL',
  KENNEL_POSITION_MODAL = 'KENNEL_POSITION_MODAL',
  KENNEL_QUARANTINE = 'KENNEL_QUARANTINE',
  KENNEL_REMOVE_QUARANTINE = 'KENNEL_REMOVE_QUARANTINE',
  KENNEL_UNAVAILABLE = 'KENNEL_UNAVAILABLE',
  MEDICAL_FILES = 'MEDICAL_FILES',
  MERGE_PEOPLE = 'MERGE_PEOPLE',
  NOTES_DIALOG = 'NOTES_DIALOG',
  DELETE_NOTE = 'DELETE_NOTE',
  PARTNER_ACTIVE_USER = 'PARTNER_ACTIVE_USER',
  PARTNER_CONTACT_EDIT = 'PARTNER_CONTACT_EDIT',
  PARTNER_CONTACT_NEW = 'PARTNER_CONTACT_NEW',
  PARTNER_DELETE_CONTACT = 'PARTNER_DELETE_CONTACT',
  PARTNER_DELETE_PROFILE_IMAGE = 'PARTNER_DELETE_PROFILE_IMAGE',
  PARTNER_DELETE_USER = 'PARTNER_DELETE_USER',
  PARTNER_EDIT_PROFILE_INFO = 'PARTNER_EDIT_PROFILE_INFO',
  PARTNER_EDIT_PROFILE_CUSTOM_FIELDS = 'PARTNER_EDIT_PROFILE_CUSTOM_FIELDS',
  PARTNER_EDIT_TRANSFER_ID = 'PARTNER_EDIT_TRANSFER_ID',
  PARTNER_LOCATION_DELETE = 'PARTNER_LOCATION_DELETE',
  PARTNER_LOCATION_EDIT = 'PARTNER_LOCATION_EDIT',
  PARTNER_LOCATION_NEW = 'PARTNER_LOCATION_NEW',
  PEOPLE_ADD_ADDRESS = 'PEOPLE_ADD_ADDRESS',
  PEOPLE_ASSOCIATE_CASES = 'PEOPLE_ASSOCIATE_CASES',
  PEOPLE_DELETE_ADDRESS = 'PEOPLE_DELETE_ADDRESS',
  PEOPLE_DELETE_DONATIONS = 'PEOPLE_DELETE_DONATIONS',
  PEOPLE_UNLINK_CONTACT = 'PEOPLE_UNLINK_CONTACT',
  PEOPLE_DELETE_PROFILE = 'PEOPLE_DELETE_PROFILE',
  PEOPLE_DELETE_PROFILE_PHOTO = 'PEOPLE_DELETE_PROFILE_PHOTO',
  PEOPLE_DO_NOT_FLAG = 'PEOPLE_DO_NOT_FLAG',
  PEOPLE_TAGS_DO_NOT_ADOPT_CONFIRM = 'PEOPLE_TAGS_DO_NOT_ADOPT_CONFIRM',
  PEOPLE_DONATION = 'PEOPLE_DONATION',
  PEOPLE_EDIT_ADOPT_ACCOUNT = 'PEOPLE_EDIT_ADOPT_ACCOUNT',
  PEOPLE_EDIT_PROFILE_CUSTOM_FIELDS = 'PEOPLE_EDIT_PROFILE_CUSTOM_FIELDS',
  PEOPLE_LINKED_CONTACT = 'PEOPLE_LINKED_CONTACT',
  PEOPLE_LINK_EXISTING_PEOPLE = 'PEOPLE_LINK_EXISTING_PEOPLE',
  PEOPLE_LINKED_CONTACT_TYPE = 'PEOPLE_LINKED_CONTACT_TYPE',
  PEOPLE_MERGE = 'PEOPLE_MERGE',
  PEOPLE_OPT_IN_CONFIRM = 'PEOPLE_OPT_IN_CONFIRM',
  PEOPLE_OPT_OUT_CONFIRM = 'PEOPLE_OPT_OUT_CONFIRM',
  PEOPLE_REACTIVE_PROFILE = 'PEOPLE_REACTIVE_PROFILE',
  PEOPLE_REMOVE_ANIMAL = 'PEOPLE_REMOVE_ANIMAL',
  PEOPLE_REMOVE_DROPPED_ANIMAL = 'PEOPLE_REMOVE_DROPPED_ANIMAL',
  PEOPLE_SEND_ADOPT_LINK = 'PEOPLE_SEND_ADOPT_LINK',
  PROCESS_PAYMENT = 'PROCESS_PAYMENT',
  REGISTER_SHELTER = 'REGISTER_SHELTER',
  REVOKE_FOSTER_APP = 'REVOKE_FOSTER_APP',
  REMOVE_PEOPLE_FROM_ADMISSION_HISTORY_INTAKE = 'REMOVE_PEOPLE_FROM_ADMISSION_HISTORY_INTAKE',
  REMOVE_PEOPLE_FROM_ADMISSION_HISTORY_OUTCOME = 'REMOVE_PEOPLE_FROM_ADMISSION_HISTORY_OUTCOME',
  REMOVE_PARTNER_FROM_ADMISSION_HISTORY_INTAKE = 'REMOVE_PARTNER_FROM_ADMISSION_HISTORY_INTAKE',
  REMOVE_PARTNER_FROM_ADMISSION_HISTORY_OUTCOME = 'REMOVE_PARTNER_FROM_ADMISSION_HISTORY_OUTCOME',
  REPORT_TEMPLATE_COPY = 'REPORT_TEMPLATE_COPY',
  REPORT_TEMPLATE_DETAILS = 'REPORT_TEMPLATE_DETAILS',
  SAVED_REPORT_DELETE = 'SAVED_REPORT_DELETE',
  SAVED_REPORT_SAVE = 'SAVED_REPORT_SAVE',
  SAVED_REPORT_UPDATE = 'SAVED_REPORT_UPDATE',
  SEND_SAC = 'SEND_SAC',
  SETTINGS_ADOPTION_CONTRACT_DETAILS = 'SETTINGS_ADOPTION_CONTRACT_DETAILS',
  SETTINGS_DELETE_ADOPTION_CONTRACT = 'SETTINGS_DELETE_ADOPTION_CONTRACT',
  SETTINGS_DELETE_SURGERY_PRINT_FORM = 'SETTINGS_DELETE_SURGERY_PRINT_FORM',
  SETTINGS_DISCARD_ADOPTION_CONTRACT = 'SETTINGS_DISCARD_ADOPTION_CONTRACT',
  SETTINGS_DISCARD_SURGERY_PRINT_FORM = 'SETTINGS_DISCARD_SURGERY_PRINT_FORM',
  SETTINGS_DUPLICATE_SURGERY_PRINT_FORM = 'SETTINGS_DUPLICATE_SURGERY_PRINT_FORM',
  SETTINGS_SURGERY_PRINT_FORM_DETAILS = 'SETTINGS_SURGERY_PRINT_FORM_DETAILS',
  SETTINGS_WEBSITE_CREATE_PAGE = 'SETTINGS_WEBSITE_CREATE_PAGE',
  SETTINGS_WEBSITE_DELETE_PAGE = 'SETTINGS_WEBSITE_DELETE_PAGE',
  SETTINGS_WEBSITE_PAGE_SETTINGS = 'SETTINGS_WEBSITE_PAGE_SETTINGS',
  SETTINGS_WEBSITE_ROLLBACK = 'SETTINGS_WEBSITE_ROLLBACK',
  SHELTER_INFO_CHANGE_MODULE_STATUS = 'SHELTER_INFO_CHANGE_MODULE_STATUS',
  SHELTER_INFO_TWO_FACTOR_EMAIL_CONFIRM = 'SHELTER_INFO_TWO_FACTOR_EMAIL_CONFIRM',
  SHELTER_INFO_TWO_FACTOR_DISABLE_CONFIRM = 'SHELTER_INFO_TWO_FACTOR_DISABLE_CONFIRM',
  SHELTER_INFO_TWO_FACTOR_FORGET_TRUSTED_DEVICES_CONFIRM = 'SHELTER_INFO_TWO_FACTOR_FORGET_TRUSTED_DEVICES_CONFIRM',
  SHOW_HIDE_COLUMNS = 'SHOW_HIDE_COLUMNS',
  STAFF_USER_ACTIVE_MODAL = 'STAFF_USER_ACTIVE_MODAL',
  STAFF_USER_ADD_CONTACT = 'STAFF_USER_ADD_CONTACT',
  STAFF_USER_ADD_TASK = 'STAFF_USER_ADD_TASK',
  STAFF_USER_COMPLETE_TASK = 'STAFF_USER_COMPLETE_TASK',
  STAFF_USER_DELETE_CONTACT = 'STAFF_USER_DELETE_CONTACT',
  STAFF_USER_DELETE_MODAL = 'STAFF_USER_DELETE_MODAL',
  STAFF_USER_DELTE_IMAGE_MODAL = 'STAFF_USER_DELTE_IMAGE_MODAL',
  STAFF_USER_EDIT_CONTACT = 'STAFF_USER_EDIT_CONTACT',
  STAFF_USER_EDIT_CUSTOM_FIELDS = 'STAFF_USER_EDIT_CUSTOM_FIELDS',
  STAFF_USER_EDIT_INFO = 'STAFF_USER_EDIT_INFO',
  STAFF_USER_EDIT_ROLE = 'STAFF_USER_EDIT_ROLE',
  STAFF_USER_REPORTS_ALERTS = 'STAFF_USER_REPORTS_ALERTS',
  STAFF_USER_REQUEST_PASSWORD_RESET = 'STAFF_USER_REQUEST_PASSWORD_RESET',
  STAFF_USER_RESET_PASSWORD = 'STAFF_USER_RESET_PASSWORD',
  STAFF_USER_RESET_TWO_FACTOR_VERIFICATION = 'STAFF_USER_RESET_TWO_FACTOR_VERIFICATION',
  TNVR_ANIMAL_ADD_MODAL = 'TNVR_ANIMAL_ADD_MODAL',
  TNVR_REPORTING_PARTY_MODAL = 'TNVR_REPORTING_PARTY_MODAL',
  TNVR_CONTACT_ADD_MODAL = 'TNVR_CONTACT_ADD_MODAL',
  TNVR_CONTACT_EDIT_MODAL = 'TNVR_CONTACT_EDIT_MODAL',
  TNVR_DELETE_REPORTING_PARTY = 'TNVR_DELETE_REPORTING_PARTY',
  TNVR_DELETE_CONTACT = 'TNVR_DELETE_CONTACT',
  TNVR_LOCATION_MODAL = 'TNVR_LOCATION_MODAL',
  TRANSPORT_ADD_ANIMAL = 'TRANSPORT_ADD_ANIMAL',
  TRANSPORT_HELD_ANIMALS = 'TRANSPORT_HELD_ANIMALS',
  TRANSPORT_INTAKE_ANIMAL = 'TRANSPORT_INTAKE_ANIMAL',
  TRANSPORT_LOCATION = 'TRANSPORT_LOCATION',
  TRANSPORT_OUTCOME = 'TRANSPORT_OUTCOME',
  UPDATE_ANIMAL_NEW_HOLD_LIMITS_MODAL = 'UPDATE_ANIMAL_NEW_HOLD_LIMITS_MODAL',
  UPDATE_HOW_TO_VIDEOS = 'UPDATE_HOW_TO_VIDEOS',
  UPDATE_HOW_TO_VIDEO_ORDER = 'UPDATE_HOW_TO_VIDEO_ORDER',
  VOUCHER_EMAIL = 'VOUCHER_EMAIL',
  WHATS_NEW_STATUS_CONFIRM = 'WHATS_NEW_STATUS_CONFIRM',
  WHATS_NEW_TIP_TEXT_EDIT = 'WHATS_NEW_TIP_TEXT_EDIT',
}

export { SYSTEM_MODALS };
